import ReactGA from 'react-ga';
import { notIsEmptyString } from '../utils';
import { guc } from './Localisation';

export const logPageView = () => typeof window != 'undefined' && ReactGA.pageview(window.location.pathname + window.location.search);

export const logEvent = (category, action, label, value, eventName, eventType = EVENT_TYPE.TRACK_CUSTOM) => {
    ReactGA.event({ category, action, label, value });
    eventName = notIsEmptyString(eventName) ? eventName : action;
    notIsEmptyString(guc('fb_insights_tracker_id')) && window.fbq && window.fbq(eventType, eventName, {
        content_category: 'OAM ' + category,
        content_name: action
    });
}

export const EVENT_CATEGORIES = Object.freeze({
    WHATSAPP_WIDGET: 'Whatsapp Widget',
    PARTNER_PAGE: 'Partner Page',
    MYRTLE_BEACH_2021_PAGE: 'Myrtle Beach 2021 Page',
    PROSPERITY_PAGE: 'Prosperity Page',
    MISSION_1000_PAGE: 'Mission 1000 Page',
    STAYCATION_PAGE: 'Staycation Page',
    CASE_STUDIES_PAGE: 'CaseStudies Page',
    STATIC_HEADER: 'Static Header',
    STATIC_FOOTER: 'Static Footer',
    PARTNER_PAGE_LANDING_FORM: 'Partner Page landing form',
    PARTNER_PAGE_LANDING_FORM_HOTEL: 'Partner Page landing form Hotel',
    PARTNER_PAGE_LANDING_FORM_HOME: 'Partner Page landing form Home',
    HEADER: 'Header',
    UK_REFERRAL_PAGE: 'UK_REFERRAL_PAGE',
});

export const EVENT_ACTIONS = Object.freeze({
    CLICKED: 'Clicked',
    START_CHAT_CLICKED: 'Start Chat Clicked',
    EMAIL_US_LINK_CLICKED: 'Email Us Link Clicked',
    CALL_US_LINK_CLICKED: 'Call Us Link Clicked',
    ABOUT_OYO_CLICKED: 'About OYO Clicked',
    HOME_PAGE_LINK_CLICKED: 'Home Page Link Clicked',
    TNC_CLICKED: 'Terms and Conditions Clicked',
    GET_STARTED_CLICKED: 'Get Started Clicked',
    ENTER_TO_WIN_CLICKED: 'Enter to win Clicked',
    HEADER_TNC_CLICKED: 'Header TnC Clicked',
    TNC_SECTION_CLICKED: 'TnC Section Clicked',
    LEARN_MORE_CLICKED: 'Learn More Clicked',
    OYO_GIVEAWAY_CLICKED: 'OYO Giveaway Clicked',
    STEP_1_ROOM_COUNT_ENTERED: 'Step 1 Room Count entered',
    STEP_1_GET_ASSOCIATED_CLICKED: 'Step 1 Get Associated clicked',
    STEP_2_REQUEST_A_CALL_CLICKED: 'Step 2 Request a call clicked',
    GENERATE_OTP_CLICKED: 'Generate OTP clicked',
    LOCATION_ENTERED: 'Location entered',
    ROOM_COUNT_ENTERED: 'Room Count entered',
    TESTIMONIAL_VIDEO_1_PLAYED: 'Testimonial video 1 played',
    TESTIMONIAL_VIDEO_2_PLAYED: 'Testimonial video 2 played',
    TESTIMONIAL_VIDEO_3_PLAYED: 'Testimonial video 3 played',
    NAME_ENTERED: 'Name entered',
    MOBILE_NUMBER_ENTERED: 'Mobile number entered',
    ADDRESS_ENTERED: 'Address entered',
    STRUCTURE_TYPE_SELECTED: 'Structure type selected',
    STEP_1_REQUEST_A_CALL_CLICKED: 'Step 1 Request a call clicked',
    STEP_2_SUBMIT_AND_FINISH_CLICKED: 'Step 2 Submit and Finish clicked',
    STEP_3_SUBMIT_AND_FINISH_CLICKED: 'Step 3 Submit and Finish clicked',
    PROPERTY_NAME_ENTERED: 'Property name entered',
    EMAIL_ENTERED: 'Email entered',
    STRUCTURE_TYPE_ENTERED: 'Structure type entered',
    OCCUPANY_STATUS_ENTERED: 'Occupancy status entered',
    ARE_YOU_A_OWNER_SELECTED: 'Are you a owner or not selected'
});

export const EVENT_TYPE = Object.freeze({
    TRACK: 'track',
    TRACK_CUSTOM: 'trackCustom',
});

export const EVENT_NAME = Object.freeze({
    LEAD: 'Lead',
});
